import { useState } from 'react';

import { useGetServiceTypes } from '../../api/getServiceTypes';
import { dictionaryTypes } from '../../types';
import { DictionaryList } from '../DictionaryList';

import { ServiceTypesRow } from './ServiceTypesRow';

export const ServiceTypesList = () => {
  const [viewMode, setViewMode] = useState<dictionaryTypes.ViewMode>('active');
  const { data, isLoading, isFetching, isError, refetch } = useGetServiceTypes({ viewMode });
  const serviceTypes = data?.serviceTypes ?? [];

  return (
    <DictionaryList
      viewMode={viewMode}
      onViewModeChange={setViewMode}
      isLoading={isLoading}
      isFetching={isFetching}
      isError={isError}
      onRetry={refetch}
      columnLabel="Service type"
      errorText="Failed to load service types"
      emptyText={viewMode === 'archived' ? 'No archived service types' : 'No service types'}
      isEmpty={serviceTypes.length === 0}
    >
      {serviceTypes.map((serviceType) => (
        <ServiceTypesRow key={serviceType._id} serviceType={serviceType} />
      ))}
    </DictionaryList>
  );
};
